export enum PlaylistTemplate {
  Layout1 = 0,
  Layout2 = 1,
  Layout3 = 2,
  Layout4 = 3,
  Layout5 = 4,
  Layout6 = 5,
  Layout7 = 6,
}